import React, { useContext, useState, useMemo } from 'react'
import { Drawer, Typography, Box, CardHeader } from '@mui/material'
import { LocalStorage, Services } from '../../../../services'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'
import { AuthContext } from '../../../../contexts/AuthContext'
import { InputButton } from '../../../Simple/'
import RouterHook from '../../../../contexts/RouterHook'
import moment from 'moment'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'

export default function ResumoAgendConf() {
  // Router
  const serverRouter = RouterHook()

  const { sttAuthCtx } = useContext(AuthContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { sttCtxAgend } = useContext(AgendamentoContext)
  const { actionsChkt } = useContext(CheckoutContext)

  const [discountValue, setDiscountValue] = useState(0)

  const reagendamento = sttCtxAgend.reagendamento

  const pagamentoLocal =
    Object.keys(reagendamento).length > 0
      ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' || reagendamento.formaPagamento === 'LOCAL' || reagendamento.formaPagamento === 'DINHEIRO'
      : false

  const calculateTotalValue = useMemo(() => {
    const selectedHorarios = sttPg.selectedHorarios
    let totalValue = 0
    let totalDiscount = 0

    const groupedByGrade = selectedHorarios.reduce((acc, horario) => {
      const gradeId = horario.idgrade
      if (!acc[gradeId]) acc[gradeId] = []
      acc[gradeId].push(horario)
      return acc
    }, {})

    Object.values(groupedByGrade).forEach(horarios => {
      const firstHorario = horarios[0]
      const grade = sttPg.selectedQuadra.grades.find(g => g.idgrade === firstHorario.idgrade)

      // soma de valores já existentes (promoções pontuais)
      let gradeTotalValue = horarios.reduce((sum, h) => {
        if (h.valorPromocional) totalDiscount += h.valor - h.valorPromocional
        return sum + (h.promocao ? h.valorPromocional : h.valor)
      }, 0)

      // regra de desconto progressivo (ou único se progressao == null)
      if (grade && grade.descontoProgressivo !== null) {
        const { minimo, progressao, valor } = grade.descontoProgressivo
        // calcula duração total em minutos
        const totalDuration = horarios.reduce((sum, h) => sum + moment(h.dataFinal).diff(moment(h.dataInicio), 'minutes'), 0)

        if (totalDuration >= minimo) {
          let totalGradeDiscount = 0

          if (progressao) {
            // desconto a cada 'progressao' minutos
            const discountMultiples = Math.floor(totalDuration / progressao)
            totalGradeDiscount = discountMultiples * valor
          } else {
            // quando progressao é null, aplica o desconto apenas uma vez
            totalGradeDiscount = valor
          }

          gradeTotalValue -= totalGradeDiscount
          totalDiscount += totalGradeDiscount
        }
      }

      totalValue += gradeTotalValue
    })

    setDiscountValue(totalDiscount !== 0 ? totalDiscount.toFixed(2).replace('.', ',') : 0)

    return totalValue.toFixed(2).replace('.', ',')
  }, [sttPg.selectedHorarios])

  //console.log('ResumoAgendConf', sttPg)

  function BuscaGrade() {
    let grade = sttPg.selectedQuadra.grades.find(grade => grade.idgrade === sttPg.selectedHorarios[0].idgrade)
    // se não achou procura em todas as quadras
    if (!grade) {
      sttPg.empresa.qradras.forEach(quadra => {
        grade = quadra.grades.find(grade => grade.idgrade === sttPg.selectedHorarios[0].idgrade)
        if (grade) {
          sttPg.selectedQuadra = quadra
          return grade
        }
      })
    }
    // verifica se achou a grade
    if (!grade) {
      //console.error('Grade não encontrada')
      return null
    }
    return grade
  }

  const grade = BuscaGrade()
  const minAgendavel = grade ? grade.minAgendavel : 0

  function sendToCheckout() {
    const objtCkt = {
      valorDesconto: parseFloat(discountValue ? discountValue.replace(',', '.') : 0),
      horarioAvulso: true,
      valorTotal: parseFloat(calculateTotalValue.replace(',', '.')),
      quadra: sttPg.selectedQuadra,
      agenda: sttPg.selectedHorarios.sort((a, b) => new Date(a.dataInicio) - new Date(b.dataInicio)),
      dia: moment(sttPg.selectedDay).format('YYYY-MM-DD'),
    }

    let categoria = null
    if (Object.keys(reagendamento).length > 0) {
      // Check if the sport category from reagendamento exists in the selected court's categories
      const categoriaExists = sttPg.selectedQuadra.categoriasEsporte.some(
        cat => cat.idcategoriaEsporte === reagendamento.categoriaEsporte.idcategoriaEsporte,
      )
      categoria = categoriaExists ? reagendamento.categoriaEsporte : null
    }
    if (sttPg.selectedQuadra.categoriasEsporte.length === 1 && Object.keys(reagendamento).length === 0)
      categoria = sttPg.selectedQuadra.categoriasEsporte[0]

    // const porcentagem_sinal = sttPg.selectedQuadra.regraAgendamento.porcentagemSinal
    const data = {
      agendamentoConfirme: objtCkt,
      esporteSelected: categoria,
      cpfObrigatorio: null,
      metodPay: null,
      cupomAplicado: null,
      selTotal:
        sttPg.selectedQuadra.regraAgendamento.tipoPagamento === 'TOTAL' ||
        (Object.keys(reagendamento).length > 0 &&
          (reagendamento.valorAPagar === reagendamento.valorTotal - reagendamento.valorDesconto ||
            reagendamento.valorRealizado === reagendamento.valorTotal - reagendamento.valorDesconto))
          ? true
          : false,
      selSinal:
        sttPg.selectedQuadra.regraAgendamento.tipoPagamento === 'SINAL' ||
        (Object.keys(reagendamento).length > 0 &&
          reagendamento.valorRealizado !== 0 &&
          reagendamento.valorRealizado !== reagendamento.valorTotal - reagendamento.valorDesconto)
          ? true
          : false,
      selPix:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'PIX' && sttPg.selectedQuadra.regraAgendamento.recebimentos_pix_avulso
          : false,
      selCardCredit:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'CARTAO_CREDITO' && sttPg.selectedQuadra.regraAgendamento.recebimentos_cartao_avulso
          : false,
      selMaqCredit:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' && sttPg.selectedQuadra.regraAgendamento.recebimentos_maquina_local_avulso
          : false,
      selDinheiro:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'DINHEIRO' && sttPg.selectedQuadra.regraAgendamento.recebimentos_dinheiro_avulso
          : false,
      diaria: null,
    }
    LocalStorage.set('agendamento-selecionado', objtCkt)
    actionsChkt.handleSttCtxBuff(data)
    actionsCtxEmps.confirmarPedido(sttPg.selectedQuadra)
  }

  return (
    <Drawer
      anchor='bottom'
      open={sttPg.resumoPedido}
      variant='persistent'
      PaperProps={{
        sx: {
          background: 'linear-gradient(90deg, rgba(255,112,67,1) 40%, rgba(173,50,14,1) 100%)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80px',
        },
      }}
    >
      {Object.keys(reagendamento).length === 0 ||
      (Object.keys(reagendamento).length > 0 && pagamentoLocal) ||
      (Object.keys(reagendamento).length > 0 && !pagamentoLocal && parseFloat(calculateTotalValue.replace(',', '.')) === reagendamento.valorTotal) ? (
        <CardHeader
          sx={stDesk.containCardHeader}
          title={
            <Typography align='left' color='white' sx={{ typography: { xs: 'h6', lg: 'h5' } }}>
              Resumo do {Object.keys(reagendamento).length > 0 && 're'}agendamento na {sttPg.selectedQuadra.descricao}
            </Typography>
          }
          subheader={
            <Typography variant='h6' align='left' color='white'>
              {sttPg.selectedHorarios.length} horário{sttPg.selectedHorarios.length > 1 ? 's' : ''} selecionado das{' '}
              {moment(sttPg.selectedHorarios[0].dataInicio).format('HH:mm')} às{' '}
              {moment(sttPg.selectedHorarios[sttPg.selectedHorarios.length - 1].dataFinal).format('HH:mm')} de{' '}
              {moment(sttPg.selectedDay).format('ddd, DD/MM/YY')}
            </Typography>
          }
          action={
            <Box sx={stDesk.containButonValues}>
              <Box sx={stDesk.containValues}>
                {discountValue > 0 && (
                  <Typography variant='body2' sx={stDesk.textDesc}>
                    - R$ {discountValue}
                  </Typography>
                )}
                <Typography sx={stDesk.textValue} variant='h6'>
                  {Object.keys(reagendamento).length === 0 || (Object.keys(reagendamento).length > 0 && pagamentoLocal)
                    ? `Valor total: R$ ${calculateTotalValue}`
                    : reagendamento.valorTotal === parseFloat(calculateTotalValue)
                      ? 'Sem custos'
                      : `Saldo excedente: R$ ${parseFloat(calculateTotalValue.replace(',', '.')) - reagendamento.valorTotal}`}
                </Typography>
              </Box>
              <InputButton
                disabled={Services.IsMinAgendavel(sttPg.selectedHorarios) < minAgendavel}
                color={Services.IsMinAgendavel(sttPg.selectedHorarios) < minAgendavel ? `primary` : 'secondary'}
                onClick={sttAuthCtx.isLogged ? sendToCheckout : () => serverRouter('login')}
                sx={{ '&:hover': { backgroundColor: 'white' } }}
              >
                <Typography variant='h6' color='secondary.lightOrange'>
                  {sttAuthCtx.isLogged
                    ? Services.IsMinAgendavel(sttPg.selectedHorarios) < minAgendavel
                      ? `Mínimo: ${Services.FormatDuration(minAgendavel, true)}`
                      : 'Escolher horário'
                    : 'Entrar'}
                </Typography>
              </InputButton>
            </Box>
          }
        />
      ) : (
        Object.keys(reagendamento).length > 0 &&
        !pagamentoLocal &&
        (parseFloat(calculateTotalValue.replace(',', '.')) < reagendamento.valorTotal ||
          parseFloat(calculateTotalValue.replace(',', '.')) > reagendamento.valorTotal) && (
          <Typography align='center' color='white' sx={{ typography: { xs: 'h6', lg: 'h5' } }}>
            O novo horário deve ter valor igual à R$ {reagendamento.valorTotal.toFixed(2).replace('.', ',')}
            {calculateTotalValue !== '0,00' ? ', você selecionou R$ ' + calculateTotalValue : ''}
          </Typography>
        )
      )}
    </Drawer>
  )
}

const stDesk = {
  containCardHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    maxWidth: '1200px',
    width: '100%',
    padding: '0px 20px',
    overflow: 'hidden',
  },
  containButonValues: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '15px',
    marginTop: '5px',
    padding: '10px 0',
  },
  containValues: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '15px',
  },
  textValue: {
    color: 'white',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  textDesc: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    backgroundColor: '#11bf68',
    padding: '4px 8px 3px 8px',
    borderRadius: '14px',
    textAlign: 'center',

    color: '#006b2d',
    marginBottom: '3px',
    fontSize: '0.8rem',
  },
}
